/**
 * PassengersTab — admin Fleet → Passengers sub-tab.
 *
 * Extracted from FleetPanel.jsx (Phase 2 P2 decomposition · 2026-06).
 * Behaviour byte-identical to the inlined block: same testids,
 * same "ACCOUNT" pill rendering, same toggle / delete button wiring.
 * The two callbacks (onToggleAccount, onDelete) are passed straight
 * through from Admin.jsx — no API contract changed.
 */
import React from "react";
import { Briefcase, Trash2 } from "lucide-react";

export const PassengersTab = ({ passengers, onToggleAccount, onDelete }) => {
  if (!passengers || passengers.length === 0) {
    return <div className="text-center py-12 text-sm text-muted-foreground">No passengers yet.</div>;
  }
  return (
    <div data-testid="passengers-tab">
      {passengers.map((p) => (
        <div key={p.id} className="border border-border p-3 flex items-center justify-between transition-card mb-2" data-testid={`passenger-row-${p.id}`}>
          <div className="min-w-0 flex-1">
            <div className="font-semibold text-sm truncate flex items-center gap-2">
              {p.name}
              {p.is_account_customer && (
                <span className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 bg-[#EFF3FF] text-[#002FA7] border border-[#002FA7]" data-testid={`account-badge-${p.id}`}>
                  <Briefcase className="w-2.5 h-2.5" /> ACCOUNT
                </span>
              )}
            </div>
            <div className="label-mini text-muted-foreground truncate">
              {p.email}{p.account_company ? ` · ${p.account_company}` : ""}
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button
              onClick={() => onToggleAccount(p)}
              className={`text-xs px-2 py-1 border transition-colors ${p.is_account_customer ? "bg-[#002FA7] text-white border-[#002FA7] hover:bg-[#001f6e]" : "border-border hover:bg-secondary"}`}
              data-testid={`toggle-account-${p.id}`}
              title="Toggle corporate account"
            >
              <Briefcase className="w-3 h-3" />
            </button>
            <button
              onClick={() => onDelete(p.id, "passenger")}
              className="text-muted-foreground hover:text-destructive p-2"
              data-testid={`delete-passenger-${p.id}`}
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PassengersTab;
